import { Ortak } from './../../../providers/ortak';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { GelirgidereklePage } from './gelirgiderekle/gelirgiderekle';
import { NumberValueAccessor } from '@angular/forms/src/directives';

/**
 * Generated class for the GelirgiderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-gelirgider',
  templateUrl: 'gelirgider.html',
})
export class GelirgiderPage {
  aranan="";
  skip:number=0;
  take:number=50;
  GelirListesi=[];
  GiderListesi=[];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
   this.GelirGetir(null);
   this.GiderGetir(null);
  }
  ionViewDidEnter(){
   this.GelirGetir(null);
   this.GiderGetir(null);
  }

  

  GelirGetir(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "GelirListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.GelirListesi = sonuc.SonucObject;
   
   
 
    })
  }
  GiderGetir(e){
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "GiderListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.GiderListesi = sonuc.SonucObject;
   
   
 
    })

  }
  durumkayitlari(e) {

    if (e.keyCode == 13) {
      this.GelirGetir(e);
      this.GiderGetir(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(GelirgidereklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  kayitduzenle(kayit){
    let modal = this.modalCtrl.create(GelirgidereklePage, { KayitVw: kayit });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
 
  }
  DurumSil(kayit) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", kayit.ID);

      this.bllOrtak.islem(formData, "AciklamaSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
     
     
    })
   this.GelirGetir(null);
   this.GiderGetir(null);
  }
}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/gelirgider/gelirgider.ts